import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH CHANNEL TO EDIT ********************
export const fetchChannel = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_CHANNEL_LOADING,
			payload: true
		});

		const response = await services.get(`/products/channels/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_CHANNEL_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_CHANNEL_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
